import { render, staticRenderFns } from "./addLostAndFound.vue?vue&type=template&id=1c929769&"
import script from "./addLostAndFound.vue?vue&type=script&lang=js&"
export * from "./addLostAndFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports